export default "__VITE_ASSET__CcdGkl9T__"